export const PAGE_TEMPLATES = {
  DEFAULT: 'default',
  WIDE: 'wide',
}

// Domyślnie tekst trzyma kolumnę 950 px (665 px poniżej xl).
// Wariant szeroki rozciąga tekst do 80% szerokości kontenera, ale nigdy nie schodzi poniżej 950 px
// (na węższych ekranach blok i tak nie przekroczy szerokości kontenera).
export const getPageTextWidthClass = (template) =>
  template === PAGE_TEMPLATES.WIDE ? 'max-w-[max(80%,950px)]' : 'xl:max-w-[950px] max-w-665'
